/**
 * notify — imperatywny wrapper na ToastContext (legacy `context/ToastContext`).
 *
 * Provider rejestruje swoje API w `window.__terroirToast` (patrz
 * RegisterToastBridge poniżej), a stąd korzystamy bez hooka.
 *
 * Użycie:
 *   import { notifyError, notifySuccess, notifyInfo } from '../lib/notify';
 *   notifyError('Nie udało się zapisać');
 *   notifySuccess('Zapisane');
 *
 * Fallback: jeśli provider nie zdążył się zamontować, używamy console.warn
 * + alert() (nigdy nie rzucamy w produkcji).
 */

function pick(level, msg) {
  if (typeof window === 'undefined') return;
  const api = window.__terroirToast;
  if (api && typeof api[level] === 'function') {
    api[level](msg);
    return;
  }
  // Fallback do alert tylko gdy brak providera (nie powinno się zdarzyć).
  // eslint-disable-next-line no-console
  console.warn('[notify] toast provider niedostępny:', level, msg);
  if (level === 'error' || level === 'warning') {
    // eslint-disable-next-line no-alert
    if (typeof window.alert === 'function') window.alert(String(msg || ''));
  }
}

export const notifySuccess = (msg) => pick('success', msg);
export const notifyError   = (msg) => pick('error',   msg);
export const notifyWarning = (msg) => pick('warning', msg);
export const notifyInfo    = (msg) => pick('info',    msg);
